import { render, staticRenderFns } from "./VivalecDashboard.vue?vue&type=template&id=41add4f0"
import script from "./VivalecDashboard.vue?vue&type=script&lang=ts"
export * from "./VivalecDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports